import React, { useEffect } from "react";
import { useNavigate } from "react-router";

import Button from "../../Button";
import TrashIcon from "/public/images/icons/trashRed.svg?react";

export default function ProductSummaryCard({ product, removeProducts }) {
  
  const gradient =  
    (product?.BandVenueColour || product?.BandColour)  === "Red"
      ? "#A4123F"
    : (product?.BandVenueColour || product?.BandColour) === "Blue"
      ? "#1877D3"
    : (product?.BandVenueColour || product?.BandColour) === "Grey"
      ? "#727272"
    : (product?.BandVenueColour || product?.BandColour) === "Black"
      ? "#101820"
    : (product?.BandVenueColour || product?.BandColour) === "Yellow"
      ? "#EAAA00"
    : "#F8F8F8";


    const imageSrc = (product?.OrgPartnerFriendlyName === 'sports guardian' || 
      product?.OrgPartnerFriendlyName === 'sg testing' || 
      product?.OrgPartnerFriendlyName === 'swim safely') 
    ? `https://stsportsguardianprod001.blob.core.windows.net/bandassets/sports-guardian3d_${(product?.BandVenueColour || product?.BandColour).toUpperCase()}.png`
    : (product?.BandImage || product?.Org3dImageURL);

        return (
          <div className="flex flex-row gap-[18px]">
            <div className="flex flex-col w-1/2 relative align-middle justify-center items-center">
              <div className="h-[128px] w-[128px] my-[14px] mx-[30px]">
          <div
            className={`border-[1px] border-[#E3E3E3] rounded-[4px] h-full`}
            style={{
              background: `${gradient}`,
            }}
          >
            <div
              className={`flex flex-col h-full w-full rounded-[4px]`}
              style={{
                background: `linear-gradient(134.5deg, rgba(255,255,255, 0.1) 0%, rgba(255,255,255, 0.1) 50%, ${gradient} 50.1%, ${gradient} 100%)`,
              }}
            />
          </div>
              </div>
              <div className="flex flex-col items-center h-full w-max absolute top-[3px] left-1/2 transform -translate-x-1/2">
          <img
            src={imageSrc}
            alt="band"
            className="max-w-[180px] "
          />
              </div>
            </div>
            <div className="flex flex-col w-1/2 align-middle justify-center gap-[20px]">
              <div>
                <p className="text-sportsBlack font-semibold capitalize">{product?.OrgPartnerFriendlyName} Band ({product?.BandVenueColour || product?.BandColour})</p>
                <p className="text-sportsDarkGrey text-[12px]">(x{product?.Quantity}) £{product?.LineCostFormatted || product?.Price} Each</p>
              </div>
              <div>
                <Button variant="tertiary" className="w-full !justify-start" status="nobg-red" onClick={() => removeProducts()}><TrashIcon /> Remove</Button>
              </div>
            </div>
          </div>
        );

}